import { VendorAccountStatus, VendorStatus } from '@sib/api';
import { getVendorStatusColor } from './vendor-status-styles';

const vendorAccountToVendorStatus: Record<VendorAccountStatus, VendorStatus> = {
  [VendorAccountStatus.Active]: VendorStatus.Active,
  [VendorAccountStatus.Inactive]: VendorStatus.Inactive,
};

export const getVendorAccountStatusColor = (
  status: VendorAccountStatus = VendorAccountStatus.Active
) =>
  getVendorStatusColor(
    vendorAccountToVendorStatus[status] ?? VendorStatus.Active
  );
